import React, {useMemo} from "react";

import {WideContent} from "@pg-design/grid-module";
import {pb, pt} from "@pg-design/helpers-css";

import {ISelectedRegion} from "../../../offer/list/actions/offer_list_selected_data_actions";
import {useGetReelsListQuery} from "../../api/get_reels_list";
import {ReelList} from "./ReelList";

interface IProps {
    selectedRegions: ISelectedRegion[];
    onReelsModalClose: () => void;
    className?: string;
}

export const TopListingReels = (props: IProps) => {
    const selectedRegionIds = useMemo(() => props.selectedRegions?.map((region) => region.id), [props.selectedRegions]);
    const {data, isLoading} = useGetReelsListQuery({regionIds: selectedRegionIds});

    if (!isLoading && data?.count === 0) {
        return null;
    }

    return (
        <WideContent css={[pt(1.5), pb(0)]}>
            <ReelList onAfterModalClose={props.onReelsModalClose} selectedRegions={props.selectedRegions} />
        </WideContent>
    );
};
import React, {useMemo} from "react";

import {WideContent} from "@pg-design/grid-module";
import {pb, pt} from "@pg-design/helpers-css";

import {ISelectedRegion} from "../../../offer/list/actions/offer_list_selected_data_actions";
import {useGetReelsListQuery} from "../../api/get_reels_list";
import {ReelList} from "./ReelList";

interface IProps {
    selectedRegions: ISelectedRegion[];
    onReelsModalClose: () => void;
    className?: string;
}

export const TopListingReels = (props: IProps) => {
    const selectedRegionIds = useMemo(() => props.selectedRegions?.map((region) => region.id), [props.selectedRegions]);
    const {data, isLoading} = useGetReelsListQuery({regionIds: selectedRegionIds});

    if (!isLoading && data?.count === 0) {
        return null;
    }

    return (
        <WideContent css={[pt(1.5), pb(0)]}>
            <ReelList onAfterModalClose={props.onReelsModalClose} selectedRegions={props.selectedRegions} />
        </WideContent>
    );
};
